import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { getStaffProfile, saveStaff, logEvent } from "../services/apiServices.js";
import {
  isEmail,
  isEmpty,
} from "../validators/helper.js";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { browserName, browserVersion } from "react-device-detect";

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import PageError from "../views/PageError.js";
import { useAnalytics } from "../hooks/useAnalytics.js";
import Select from 'react-select';
import { useAccess } from "../context/AccessContext.js";

export default function CreateStaff(props) {

  const [error, setError] = useState({});
  const [userForm, setuserForm] = useState({
    ID: "",
    firstname: "",
    lastname: "",
    username: "",
    password1: "",
    number: "",
    gender: "",
    age: "",
    enablefence: false,
    email: "",
    role: "admin",
    rolevalues: [3],
  });

 
  const { handlePageAccess, rolename } = useAccess();
  const roleAccess = handlePageAccess("staff")

  const navigate = useNavigate();
  const [apiError, setApiError] = useState(false);
  const { trackButtonClick } = useAnalytics();
  const handleReload = () => {
    window.location.reload();
  }
  const [plansInfo, setPlansInfo] = useState(localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null);
  useEffect(() => {
    setPlansInfo(JSON.parse(localStorage.getItem("planInfo")));
  }, [localStorage.getItem("planInfo")]);

  let staffValue = true;
  if (plansInfo != null && plansInfo?.feature?.stafflogin) {
    let usersData = props.userData;
    let loggedStaffCount = usersData.find((obj) => obj._id == props.sId)?.role;
    if (props.sId && loggedStaffCount == "staff") {
      staffValue = true;
    } else if (!plansInfo?.planUsage?.staffflag) {
      staffValue = false;
    }
  } else {
    staffValue = false;
  }

  let adminValue = true;
  if (plansInfo != null && plansInfo?.feature?.adminlogin) {

    let usersData = props.userData;
    let loggedStaffCount = usersData.find((obj) => obj._id == props.sId)?.role;

    if (props.sId && (loggedStaffCount.toLowerCase() == "admin")) {
      adminValue = true;
    } else if (!plansInfo?.planUsage?.adminflag) {
      adminValue = false;
    }
  } else {
    adminValue = false;
  }
  let accountantValue = true;
  if (plansInfo != null && plansInfo?.feature?.accountantrole) {
    let usersData = props.userData;
    let loggedStaffCount = usersData.find((obj) => obj._id == props.sId)?.role;

    if (props.sId && (loggedStaffCount == "accountant")) {
      accountantValue = true;
    } else if (!plansInfo?.planUsage?.accountantrole) {
      accountantValue = false;
    }
  } else {
    accountantValue = false;
  }

  useEffect(() => {
    if (!adminValue && !staffValue) {
      updateForm({ role: "accountant" });
    } else if (!adminValue) {
      updateForm({ role: "staff" });
    }
  }, [adminValue]);
  useEffect(() => {
    if (!adminValue && !staffValue && !accountantValue) {
      props.backallback();
      props.errorLimit();
      return;
    }
  }, [accountantValue])

  useEffect(() => {

    async function fetchData() {
      if (!props.sId) return;

      console.log(props.sId);
      const response = await getStaffProfile(props.sId);
      // console.log(response);

      if (!response) {
        return;
      }
      if (response == "false") {
        setApiError(true)
        return;
      }
      const record = await response.json();
      if (!record) {
        navigate("/");
        return;
      }
      console.log(record?.rolevalues, 'record?.rolevalues');

      const updatedRecord = {
        ...record,
        rolevalues: record?.rolevalues?.length > 0 ? record?.rolevalues : record.role == "admin" ? [1] : [3]
      };
      console.log(updatedRecord, 'updatedRecord');

      setuserForm(updatedRecord);

      if (!record.username) {
        updateForm({ username: record.email })
      }
    }

    fetchData();
  }, [props.sId]);


  function updateForm(value) {
    setuserForm((prev) => {
      const newState = { ...prev, ...value };
      return JSON.stringify(prev) === JSON.stringify(newState) ? prev : newState;
    });
  }
  const isAlphabetical = (str) => /^[a-zA-Z]+$/.test(str);

  let validateForm = (e) => {
    console.log("Validating form...");
    let errors = {};

    if (!isEmail(userForm.email)) {
      errors.email = "Please enter valid email";
    }

    if (isEmpty(userForm.username)) {
      errors.username = "Username can't be blank";
    }
    if (isEmpty(userForm.firstname)) {
      errors.firstname = "First Name can't be blank";
    } else if (!isEmpty(userForm.firstname) && !isAlphabetical(userForm.firstname)) {
      errors.firstname = "Name can be only Alhabets  ";
    }
    if (isEmpty(userForm.lastname)) {
      errors.lastname = "Last Name can't be blank";
    } else if (!isEmpty(userForm.lastname) && !isAlphabetical(userForm.lastname)) {
      errors.lastname = "Name can be only Alhabets  ";
    }
    if (isEmpty(userForm.number)) {
      errors.number = "Contact Number can't be blank";
    } else if (!isValidPhoneNumber(userForm.number)) {
      errors.number = "Please enter valid Contact Number";
    }


    console.log(errors);
    if (isEmpty(errors)) {
      return true;
    } else {
      return errors;
    }
  };
  function setUserSession(userInfo) {
    localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));
  }

  console.log(userForm);
  async function onSubmit(e) {
    e.preventDefault();
    const updates = {
      ID: userForm.ID,
      fname: userForm.firstname,
      lname: userForm.lastname,
      username: userForm.username,
      password: userForm.password1,
      number: userForm.number,
      gender: userForm.gender,
      age: userForm.age,
      // enablefence: userForm.role != "staff" ? false : userForm?.enablefence,
      enablefence: userForm?.enablefence,
      email: userForm.email,
      role: userForm.role,
      rolevalues: userForm.rolevalues.length > 0 ? userForm.rolevalues : [3],
      _id: props.sId ? props.sId : null,
    };
    console.log(userForm);
    console.log("inn if");
    let errors = validateForm(e);
    let flag;

    if (errors == true) {
      if (localStorage.getItem("loggedUserInfo")) {
        let saverep = await saveStaff(
          updates,
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (saverep == "false") {
          setApiError(true)
          return;
        }
        let staff = await saverep.json();
        console.log(staff);
        let ip = localStorage.getItem("ipaddress");
        let browserinfo = browserName + "-" + browserVersion + ".0.0";
        let Eventtype = "staff";
        if (props.sId == " " ? true : false) {
          flag = `Staff Created Successfully (${updates.fname} ${updates.lname})`;

          let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
          let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";

          await trackButtonClick("createStaff", "create_staff", "staff", {});

          logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
        }
        else {
          flag = `Staff Updated Successfull (${updates.fname} ${updates.lname})`;
          let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
          let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
          await trackButtonClick("createStaff", "Update_staff", "staff", {});
          logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");



          const userInfo = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")) : "";
          if (userInfo._id == props.sId) {
            userInfo.fname = userForm.firstname;
            userInfo.lname = userForm.lastname;
            userInfo.name = userForm.firstname + " " + userForm.lastname;
            userInfo.username = userForm.username;
            userInfo.number = userForm.number;
            userInfo.email = userForm.email;
            userInfo.role = userForm.role;
            userInfo.rolevalues = userForm.rolevalues.length > 0 ? userForm.rolevalues : [3]
            setUserSession(userInfo);
          }

        }

      }
      props.onbacktoStaff(flag);
      props.backallback();

      // window.location.reload(true);
    } else {
      setError(errors);
    }
  }

  const roleOptions = [
    { value: 1, label: 'Owner' },
    { value: 2, label: 'Manager' },
    { value: 3, label: 'Trainer' },
    { value: 4, label: 'FrontDesk' },
    { value: 5, label: 'Accountant' },
    { value: 6, label: 'CampaignManager' }
  ];
  return (
    <>
      {apiError ? <PageError handleReload={handleReload} /> : <div className="gym-container ">
        <form
          action="#"
          className="business-form"
          target="_blank"
          onSubmit={onSubmit}
        >

          <MDBRow>

            <MDBCol md={4} sm={12} className="pt-4">
              <label>Employee ID</label>
              <input
                className="gym-input user-pdng"
                type="text"
                name="Name"
                required=""
                value={userForm.ID}
                onChange={(e) => updateForm({ ID: e.target.value })}
              />
              {error.ID && (
                <>
                  <p className="clr-red">{error.ID}</p>
                </>
              )}
            </MDBCol>


            <MDBCol md={4} sm={12} className="pt-4">
              <label>Mobile No<span className="text-danger">*</span></label>

              <div className="d-flex align-items-center">
                <PhoneInput
                  className="gym-input user-pdng input-select d-flex p-0"
                  defaultCountry="IN"
                  placeholder="Enter phone number"
                  value={userForm.number}
                  // onInput={(e) => e.target.value = e.target.value.slice(0, 15)}
                  onChange={(value) => updateForm({ number: value })}
                />
              </div>
              {error.number && (
                <>
                  <p className="clr-red">{error.number}</p>
                </>
              )}
            </MDBCol>




            <MDBCol md={4} sm={12} className="pt-4">
              <label>First Name<span className="text-danger">*</span></label>
              <input
                className="gym-input user-pdng"
                type="text"
                name="Name"
                required=""
                value={userForm.firstname}
                onChange={(e) => updateForm({ firstname: e.target.value })}
              />
              {error.firstname && (
                <>
                  <p className="clr-red">{error.firstname}</p>
                </>
              )}
            </MDBCol>




            <MDBCol md={4} sm={12} className="pt-4">
              <label>Last Name<span className="text-danger">*</span></label>
              <input
                className="gym-input user-pdng"
                type="text"
                name="Name"
                required=""
                value={userForm.lastname}
                onChange={(e) => updateForm({ lastname: e.target.value })}
              />
              {error.lastname && (
                <>
                  <p className="clr-red">{error.lastname}</p>
                </>
              )}
            </MDBCol>




            <MDBCol md={4} sm={12} className="pt-4">
              <label>User Name<span className="text-danger">*</span></label>
              <input
                className="gym-input user-pdng"
                type="text"
                name="username"
                required=""
                value={userForm.username}
                onChange={(e) => updateForm({ username: e.target.value })}
              />
              {error.username && (
                <>
                  <p className="clr-red">{error.username}</p>
                </>
              )}
            </MDBCol>




            <MDBCol md={4} sm={12} className="pt-4">
              <label>Password</label>
              <input
                className="gym-input user-pdng"
                type="password"
                name="Name"
                required=""
                value={userForm.password1}
                onChange={(e) => updateForm({ password1: e.target.value })}
              />
              {error.password && (
                <>
                  <p className="clr-red">{error.password1}</p>
                </>
              )}
            </MDBCol>




            <MDBCol md={4} sm={12} className="pt-4">
              <label>Gender</label>
              <select
                name="gender"
                id="gender"
                className="gym-input user-pdng"
                value={userForm.gender}
                onChange={(e) => updateForm({ gender: e.target.value })}
              >
                <option value="Male" default>
                  Male
                </option>
                <option value="Female">Female</option>
              </select>
            </MDBCol>




            <MDBCol md={4} sm={12} className="pt-4">
              <label>Age</label>
              <input
                className="gym-input user-pdng"
                type="text"
                name="Name"
                required=""
                value={userForm.age}
                onChange={(e) => updateForm({ age: e.target.value })}
              />
              {error.age && (
                <>
                  <p className="clr-red">{error.age}</p>
                </>
              )}
            </MDBCol>




            <MDBCol md={4} sm={12} className="pt-4">
              <label>Email<span className="text-danger">*</span></label>
              <input
                className="gym-input user-pdng"
                type="text"
                name="Email"
                required=""
                value={userForm.email}
                onChange={(e) => updateForm({ email: e.target.value })}
              />
              {error.email && (
                <>
                  <p className="clr-red">{error.email}</p>
                </>
              )}
            </MDBCol>



            {/* 
            <MDBCol md={4} sm={12} className="pt-4 pb-5">
              {localStorage.getItem("loggedUserInfo") &&
                !(JSON.parse(localStorage.getItem("loggedUserInfo")).role == "staff") && <div>
                  <label>Role</label>
                  <select
                    name="role"
                    id="role"
                    className="gym-input user-pdng"
                    value={userForm.role}
                    onChange={(e) => updateForm({ role: e.target.value })}
                  >
                    {adminValue && <option value="admin" default>Admin</option>}
                    {staffValue && <option value="staff">Staff</option>}
                    {accountantValue && <option value="accountant">Accountant</option>}
                  </select>
                </div>}
            </MDBCol> */}

            {roleAccess?.editstaff == 1 && <MDBCol md={4} sm={12} className="pt-4 pb-5">
              {localStorage.getItem("loggedUserInfo") && (
                <div>
                  <label>Roles</label>
                  <Select
                    isMulti
                    options={roleOptions}
                    value={roleOptions.filter(option =>
                      userForm.rolevalues.includes(option.value)
                    )}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions.map(option => option.value);
                      console.log(selectedValues, 'selectedValues');

                      updateForm({ rolevalues: selectedValues.length > 0 ? selectedValues : [3] });
                    }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select roles..."
                  />
                </div>
              )}
            </MDBCol>}
            {(rolename?.includes("admin") || rolename?.includes("owner")) &&
              <div className="col-3 gym-section gym-half mt-3">
                <div className="d-flex align-items-center mt-4">
                  <label className="switchlabel mb-0">Geo-Fencing:</label>
                  <label className="switch">
                    <input className="form-control" type="checkbox" checked={userForm?.enablefence} onChange={(e) => updateForm({ enablefence: !userForm.enablefence })} />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>}
          </MDBRow>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-mdb-dismiss="modal"
              onClick={props.backallback}
            >
              {props.sId ? "Cancel" : "Back"}
            </button>
            &nbsp;
            <button
              type="submit"
              className="btn btn-primary"
              data-mdb-dismiss="modal"
            >
              {props.sId ? "Save" : "Add"}
            </button>
          </div>
        </form >
      </div >}
    </>
  );
}
